const messages = {
  "title": "Dobrodošli u BRIDGESTONE <span class='text-danger'>PLUS</span>",
  "description": "<b>Već imate račun?</b><br/>Prijavite se s vašom email adresom i lozinkom.<br/><br/><b>Novi ovdje?</b><br/>Ako ste novi korisnik, molimo registrirajte se.<br/><br/>",
  "info": "",
  "buttons": {
    "action": "Prijavite se / Registrirajte se",
    "back": "Natrag na prijavu",
    "changeLanguage": "Promijenite jezik",
    "start": "Počnite"
  },
  "languageSelect": {
    "label": "Odabir jezika",
    "description": "Molimo odaberite vaš jezik",
    "start": {
      "bsBA": "Bosanski",
      "hrBA": "Hrvatski",
      "srBA": "Srpski"
    }
  }
}

export default {
  messages
}
